import { SwapRightOutlined } from "@ant-design/icons";
import {  Row } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useDebouncedCallback } from "use-debounce";
import { RootState } from "store/Reducers";
import { handleSetAdvertListFilter } from "../ClientStates";
import FormatThousandsNumber from "apps/Common/FormatThousandsNumber";
import { FC } from "react";

const MinMaxPrice:FC<{isMobile:boolean, className:string}> = ({isMobile, className}) => {
  const { filter } = useSelector((state: RootState) => state.realState);
  const dispatch = useDispatch();
  function parseValue(value:number|string) {
    return typeof value === "string" ? parseFloat(value.replace(/,/g, '')) : value;
}
  
  const debouncedHandlePriceChange = useDebouncedCallback(
    (name: string, value: number | null) => {
      let currentFilter = { ...filter,IsSearchFilter:false };
       
      if (value) {
        if (name === "MinPrice") {
          currentFilter["MinPrice"] =  parseValue(value);
        }
        if (name === "MaxPrice") {
          currentFilter["MaxPrice"] = parseValue(value);
        }
      } else {
        if (name === "MinPrice") {
          delete currentFilter["MinPrice"];
        }
        if (name === "MaxPrice") {
          delete currentFilter["MaxPrice"];
        }
      }
      
    dispatch(handleSetAdvertListFilter({ filter: currentFilter }));
    },
    1000 
  );

  return (
    <>
       
      <Row  className={className}>
     
        <FormatThousandsNumber
          name="MinPrice"
          placeholder="Min Fiyat"
          label={isMobile?"Min Fiyat":""}
         
          xs={11}
         
          className="!m-0 !border-none"
          onInputNumberChange={(value:any) => {
            
        
            debouncedHandlePriceChange("MinPrice", value);
          }}
        />
        
         
     
        <FormatThousandsNumber
          name="MaxPrice"
          label={isMobile?"Maks Fiyat":""}
          placeholder="Maks Fiyat"
          xs={11}
         
          className="!m-0"
          onInputNumberChange={(value:any) => {
           
            debouncedHandlePriceChange("MaxPrice", value);
          }}
        />
      </Row>
       
    </>
  );
};

export default MinMaxPrice;
